import {
  Modal,
  Divider,
  Card,
  Group,
  Text,
  Badge,
  Button,
  Stack,
} from "@mantine/core";

import classes from "./SubscriptionModal.module.css";
import { useState } from "react";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

interface SubscriptionModalProps {
  opened: boolean;
  close(): void;
  title: string;
  fields: {
    planName: string;
    subNum: string;
    total: string;
    status: string;
    lBillDate: string;
    nBillDate: string;
    subID: string;
  };
}

export function SubscriptionModal(props: SubscriptionModalProps) {
  const [loading, setLoading] = useState(false);
  const [cancel, setCancel] = useState(false);

  async function handleCancel() {
    try {
      setLoading(true);
      setCancel(false);
      const response = await fetch(
        window.location.origin +
          "/server/client_service/cancel_subscription?subscriptionID=" +
          props.fields.subID
      );
      const resData = await response.json();
      console.log("Res data is", resData);

      if (!response.ok) {
        throw new Error("Failed to fetch items");
      } else {
        setLoading(false);
        setCancel(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  //   const [opened, { open, close }] = useDisclosure(false);
  // Show more details about the subsription
  return (
    <>
      <Modal
        opened={props.opened}
        onClose={props.close}
        // title="Subscription Details"
        centered
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3,
        }}
        withCloseButton={false}
      >
        <Card withBorder radius="md" className={classes.card}>
          {/* <Card.Section className={classes.imageSection}>
        <Image src="https://i.imgur.com/ZL52Q2D.png" alt="Tesla Model S" />
      </Card.Section> */}

          <Group justify="space-between" mt="md">
            <div>
              <Text fw={600} fz="xl">
                {props.fields.planName}
              </Text>
              <Text fz="xs" c="dimmed">
                {props.fields.subNum}
              </Text>
            </div>
            <Badge variant="outline">{props.fields.status}</Badge>
          </Group>

          <Card.Section className={classes.section} mt="md">
            <Text fz="sm" className={classes.label}>
              Billing Information
            </Text>

            <Group gap={8} mb={-8}>
              <div>
                <Text fz="md" c="dimmed">
                  Last Billing Date: {props.fields.lBillDate}
                </Text>

                <Text fz="md" c="dimmed">
                  Next Billing Date: {props.fields.nBillDate}
                </Text>
              </div>
            </Group>
          </Card.Section>

          <Card.Section className={classes.section}>
            <Group gap={30}>
              <div>
                <Text fz="lg" fw={700} style={{ lineHeight: 1 }}>
                  {props.fields.total}
                </Text>
                <Text
                  fz="sm"
                  c="dimmed"
                  fw={500}
                  style={{ lineHeight: 1 }}
                  mt={3}
                >
                  sub total
                </Text>
              </div>

              {!cancel ? (
                <Button
                  variant="gradient"
                  gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
                  style={{ flex: 1 }}
                  onClick={handleCancel}
                >
                  {!loading ? (
                    "Cancel"
                  ) : (
                    <LoadingSpinner size="xs" color="white" />
                  )}
                </Button>
              ) : (
                <Text>
                  Your request to cancel has been processed, the merchant will be in
                  contact soon.
                </Text>
              )}

              <Button
                variant="gradient"
                gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
                style={{ flex: 1 }}
                onClick={props.close}
              >
                Close
              </Button>
            </Group>
          </Card.Section>
        </Card>
      </Modal>
    </>
  );
}
